// extracted by mini-css-extract-plugin
export var addressFields = "_nu-0";
export var animationContainer = "_nu-1";
export var footer = "_nu-2";
export var lineItems = "_nu-3";
export var modalContent = "_nu-4";
export var orderName = "_nu-5";
export var strong = "_nu-6";
export var warning = "_nu-7";